import React, { Component } from 'react'
import { observer } from 'mobx-react'
import * as R from 'ramda'
import { v4 as uuidv4 } from 'uuid'
import i18n from 'i18next'

import Checkbox from '../../../form/Checkbox'
import Input from '../../../form/Input'
import Button from '../../../../UniformComponents/Button'

@observer
class SelfSelectRules extends Component {
    columns = ['email', 'campaign', 'onSite']

    addRow = () => {
        const { store } = this.props
        const { formData } = store

        const selfSelectQuestions = formData.selfSelectQuestions.slice()
        selfSelectQuestions.push({
            id: uuidv4(),
            value: '',
            flags: new Set(),
        })

        store.formData = R.set(R.lensPath(['selfSelectQuestions']), selfSelectQuestions, formData)
    }

    removeRow = (rowId) => {
        const { store } = this.props
        const { formData } = store

        const selfSelectQuestions = formData.selfSelectQuestions
            .slice()
            .filter(({ id }) => id !== rowId)

        store.formData = R.set(R.lensPath(['selfSelectQuestions']), selfSelectQuestions, formData)
    }

    changeValue = (({ name, value }) => {
        const { store } = this.props
        const { formData } = store

        const selfSelectQuestions = formData.selfSelectQuestions.slice()

        const index = selfSelectQuestions.findIndex((q) => q.id === name)
        if (index > -1) {
            const neValue = R.mergeRight(
                selfSelectQuestions[index],
                {
                    value,
                },
            )
            selfSelectQuestions.splice(index, 1, neValue)
        }

        store.formData = R.set(R.lensPath(['selfSelectQuestions']), selfSelectQuestions, formData)
    })

    setFlag = (id, column, checked) => {
        const { store } = this.props
        const { formData } = store

        const selfSelectQuestions = formData.selfSelectQuestions.slice()

        const index = selfSelectQuestions.findIndex((q) => q.id === id)
        if (index > -1) {
            const newValue = selfSelectQuestions[index]

            if (checked) newValue.flags.add(column)
            else newValue.flags.delete(column)

            selfSelectQuestions.splice(index, 1, newValue)
        }

        store.formData = R.set(R.lensPath(['selfSelectQuestions']), selfSelectQuestions, formData)
    }

    renderRow = (row) => {
        const { store } = this.props
        const { formData } = store
        const { id, value, flags } = row
        return (
            <tr key={id}>
                <td><Input name={id} defaultValue={value} onBlur={this.changeValue} /></td>
                {this.columns.map((column) => {
                    if (!formData.flags[column]) return <td />

                    return (
                        <td key={`${id}_${column}`}>
                            <Checkbox
                                defaultChecked={flags.has(column)}
                                className="exploriNativeCheckbox"
                                onBlur={({ value }) => this.setFlag(id, column, value)}
                            />
                        </td>
                    )
                })}
                <td>
                    <i
                        className="fa-light fa-trash"
                        onClick={() => this.removeRow(id)}
                    />
                </td>
            </tr>
        )
    }

    renderHeader = () => (
        <tr>
            <th />
            <th>{i18n.t('certification.selfSelect.email')}</th>
            <th>{i18n.t('certification.selfSelect.campaign')}</th>
            <th>{i18n.t('certification.selfSelect.onSite')}</th>
            <th />
        </tr>
    )

    render() {
        const { store } = this.props
        const { formData } = store
        const { selfSelectQuestions } = formData

        return (
            <div id="selfSelect" className="section">
                <table>
                    <thead>
                        {this.renderHeader()}
                    </thead>
                    <tbody>
                        {selfSelectQuestions.map(this.renderRow)}
                    </tbody>
                    <tfoot>
                        <td>
                            <Button
                                label={i18n.t('certification.selfSelect.add')}
                                cssClass="tertiary regular"
                                onClick={this.addRow}
                            />
                        </td>
                    </tfoot>
                </table>
            </div>
        )
    }
}

export default SelfSelectRules
